export const formatDateValue = (dateString: string): string => {
	if (!dateString) return '';

	try {
		// If it's already in YYYY-MM-DD format
		if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
			return dateString;
		}

		// If it's in DD-MM-YYYY format
		if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(dateString)) {
			const [day, month, year] = dateString.split('-').map((part) => part.padStart(2, '0'));
			return `${year}-${month}-${day}`;
		}

		// If it's in D MMM YYYY, DD MMM YYYY, D MMMM YYYY, DD MMMM YYYY format
		const monthNames = [
			'jan',
			'feb',
			'mrt',
			'apr',
			'mei',
			'jun',
			'jul',
			'aug',
			'sep',
			'okt',
			'nov',
			'dec',
		];
		const fullMonthNames = [
			'januari',
			'februari',
			'maart',
			'april',
			'mei',
			'juni',
			'juli',
			'augustus',
			'september',
			'oktober',
			'november',
			'december',
		];
		const dateParts = dateString.replace('.', '').split(' ');
		if (dateParts.length === 3) {
			const day = dateParts[0].padStart(2, '0');
			let month = monthNames.indexOf(dateParts[1].toLowerCase()) + 1;
			if (month === 0) {
				month = fullMonthNames.indexOf(dateParts[1].toLowerCase()) + 1;
			}
			const year = dateParts[2];
			return `${year}-${month.toString().padStart(2, '0')}-${day}`;
		}

		// For other formats, try parsing with Date
		const date = new Date(dateString);
		if (!Number.isNaN(date.getTime())) {
			return date.toISOString().split('T')[0];
		}
	} catch (e) {
		console.error('Error formatting date:', e);
	}
	return '';
};
